import apisauce from "apisauce";

// Constants
import { HEADERS } from "./utils/constants";
// const TAG = 'HATCH_SERVICE'
// const EXCLUDE_AUTH_PATHS = [
//   '/public',
//   '/service/app/member/v1/create',
// ]
const OLD_PUBLIC_PATH_BASE = "/public/v1";
const NEW_PUBLIC_PATH_BASE = "/public/v2";
const ZENDESK_API_BASE_URL =
  "https://hatchbaby.zendesk.com/api/v2/help_center/en-us";
const ZENDESK_API_BASE_URL_NO_LANG =
  "https://hatchbaby.zendesk.com/api/v2/help_center";

const createHeaders = (token = null) => {
  let headers = {
    [HEADERS.HATCH_CLIENT_HEADER]: HEADERS.CLIENT_NAME,
  };

  if (token) {
    headers = {
      ...headers,
      [HEADERS.HATCH_AUTH_HEADER]: token,
    };
  }

  return headers;
};

const createZendeskEndpoints = () => {
  // Create the base API AJAX request with base URL, timeout, headers, and content type
  const api = apisauce.create({
    baseURL: ZENDESK_API_BASE_URL,
    timeout: 30000,
  });

  const fetchAllCategories = () => {
    return api.get(`${ZENDESK_API_BASE_URL}/categories.json`);
  };

  const fetchAllSections = (per_page = 200) => {
    return api.get(`${ZENDESK_API_BASE_URL}/sections.json`, { per_page });
  };

  const fetchAllArticles = (per_page = 200) => {
    return api.get(`${ZENDESK_API_BASE_URL}/articles.json`, { per_page });
  };

  const fetchSectionsByCategoryId = (categoryId) => {
    return api.get(
      `${ZENDESK_API_BASE_URL}/categories/${categoryId}/sections.json`
    );
  };

  const fetchSectionDetail = (sectionId) => {
    return api.get(`${ZENDESK_API_BASE_URL}/sections/${sectionId}.json`);
  };

  const fetchArticlesBySectionId = (sectionId) => {
    return api.get(
      `${ZENDESK_API_BASE_URL}/sections/${sectionId}/articles.json`
    );
  };

  const fetchArticleDetail = (articleId) => {
    return api.get(`${ZENDESK_API_BASE_URL}/articles/${articleId}.json`);
  };

  const search = (query, page) => {
    return api.get(`${ZENDESK_API_BASE_URL_NO_LANG}/articles/search.json`, {
      query,
      page,
    });
  };

  return {
    fetchAllCategories,
    fetchAllSections,
    fetchAllArticles,
    fetchSectionsByCategoryId,
    fetchSectionDetail,
    fetchArticlesBySectionId,
    fetchArticleDetail,
    search,
  };
};

// Generally anything under /service/** is authed, and /public/** is not
const create = (apiConfig) => {
  // Create the base API AJAX request with base URL, timeout, headers, and content type
  const api = apisauce.create({
    baseURL: apiConfig.baseURL,
    timeout: 30000,
    headers: createHeaders(),
  });

  /**
   * Add our auth token header for all /api/* requests except
   * public requests
   */
  // api.axiosInstance.interceptors.request.use((request) => {
  //   // determine if we need to include auth headers based on the path
  //   // const path = url.parse(request.url).path
  //   const path = UrlParse(request.url).pathname

  //   Logger.d(TAG, `Auth Path: ${path}`)

  //   let doNotIncludeAuth = EXCLUDE_AUTH_PATHS.some(excludePath => {
  //     const regExp = new RegExp(`^${excludePath}`, 'i')

  //     return regExp.test(path)
  //   })

  //   if (!doNotIncludeAuth && apiConfig.getAccessToken()) {
  //     request.headers.Authorization = `Bearer ${apiConfig.getAccessToken()}` // eslint-disable-line no-param-reassign
  //   }

  //   Logger.d(TAG, `New request: ${JSON.stringify(request)}`)

  //   return request
  // })

  // Miscellaneous
  const getInstagramPosts = (params = null) => {
    return api.get(`${OLD_PUBLIC_PATH_BASE}/instagram`, params);
  };

  const resetPassword = ({ password, token }) => {
    const body = {
      password,
      token,
    };

    return api.post(`${NEW_PUBLIC_PATH_BASE}/newPasswordJson`, body);
  };

  const emailSignup = ({ email, ageContentTypes = [] }) => {
    return api.post(`/public/member/v1/signup`, { email, ageContentTypes });
  };

  const hatchForWorkSignup = ({
    email,
    firstName,
    lastName,
    jobTitle,
    companyName,
    numEmployees,
    phoneNumber,
    message,
  }) => {
    return api.post(`/public/hatchforwork/v1/signup`, {
      email,
      firstName,
      lastName,
      jobTitle,
      companyName,
      numEmployees,
      phoneNumber,
      message,
    });
  };

  return {
    resetPassword,
    emailSignup,
    getInstagramPosts,
    hatchForWorkSignup,
  };
};

const hatchService = { create, createZendeskEndpoints };

export default hatchService;
